@if (window.location.pathname !== '/auth') {
  <app-navbar></app-navbar>
}
<router-outlet />
<audio src="../assets/sounds/departure-notification.mp3"></audio>
<audio src="../assets/sounds/shift-alert.wav"></audio>

<section class="absolute flex flex-col top-[24px] right-[24px] z-10 items-end">
  @if (errorMessage(); as message) {
    <section
      role="alert"
      class="appearing-animation flex max-w-[500px] rounded-xl p-[10px] gap-x-[20px] bg-red-100 dark:bg-red-500 border border-red-200 dark:border-red-500 mb-[8px]"
      [class.disappearing-animation]="isErrorClosing()"
    >
      <lucide-icon
        [img]="circleX"
        class="w-[20px] h-[20px] mt-[3px] ml-[6px] shrink-0 text-red-800 dark:text-red-100"
      ></lucide-icon>
      <p class="roboto-semi-bold-m text-red-800 dark:text-white mt-[6px] mb-[6px]">
        {{ message }}
      </p>
      <button
        type="button"
        aria-label="Закрыть уведомление об ошибке"
        class="text-red-500 hover:text-red-400 dark:text-red-200 dark:hover:text-red-300 cursor-pointer h-fit ml-[26px]"
        (click)="closeErrorNotification()"
      >
        <lucide-icon class="text-inherit w-[20px] h-[20px]" [img]="crossIcon"></lucide-icon>
      </button>
    </section>
  }

  @for (notification of shiftNotifications(); track notification.type) {
    @switch (notification.type) {
      @case ('new') {
        <section
          class="appearing-animation flex w-[500px] rounded-xl p-[16px] gap-x-[20px] bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 mb-[8px]"
          [class.disappearing-animation]="notification.isClosing"
        >
          <lucide-icon
            [img]="bellIcon"
            class="w-[20px] h-[20px] mt-[2px] text-gray-700 dark:text-gray-400"
          ></lucide-icon>
          <section class="flex flex-col items-start gap-y-[4px]">
            <h3 class="roboto-semi-bold-m text-gray-800 dark:text-gray-200">
              Новая пересменка от смены — проверьте
            </h3>
            <p class="roboto-regular-sm text-gray-500 dark:text-gray-400">
              Поступил новый отчёт от смены. Проверьте его в истории пересменок.
            </p>
            <button
              class="text-red-500 hover:text-red-400 dark:text-red-500 dark:hover:text-red-400 cursor-pointer roboto-semi-bold-sm mt-[20px]"
              (click)="goToTeamShiftChangesHistoryPage()"
            >
              История пересменок
            </button>
          </section>
        </section>
      }
      @case ('approved') {
        <section
          class="appearing-animation mb-[8px] w-fit flex rounded-xl p-[10px] gap-x-[20px] bg-teal-100 dark:bg-teal-500 border border-teal-200 dark:border-teal-500"
          [class.disappearing-animation]="notification.isClosing"
        >
          <lucide-icon
            [img]="checkCircleIcon"
            class="w-[20px] h-[20px] mt-[3px] ml-[6px] text-teal-800 dark:text-teal-600"
          ></lucide-icon>
          <p class="roboto-semi-bold-m text-teal-800 dark:text-white mt-[6px] mb-[6px]">
            {{ 'Подтверждена пересменка от группы ' + notification.team }}
          </p>
          <button
            class="text-teal-500 hover:text-teal-400 dark:text-teal-200 dark:hover:text-teal-400 cursor-pointer h-fit ml-[26px]"
            (click)="closeShiftNotification(notification.type)"
          >
            <lucide-icon class="text-inherit w-[20px] h-[20px]" [img]="crossIcon"></lucide-icon>
          </button>
        </section>
      }
      @case ('declined') {
        <section
          class="appearing-animation flex w-fit rounded-xl p-[10px] gap-x-[20px] bg-red-100 dark:bg-red-500 border border-red-200 dark:border-red-500"
          [class.disappearing-animation]="notification.isClosing"
        >
          <lucide-icon
            [img]="circleX"
            class="w-[20px] h-[20px] mt-[3px] ml-[6px] text-red-800 dark:text-red-100"
          ></lucide-icon>
          <p class="roboto-semi-bold-m text-red-800 dark:text-white mt-[6px] mb-[6px]">
            {{ 'Отклонена пересменка от группы ' + notification.team }}
          </p>
          <button
            class="text-red-500 hover:text-red-400 dark:text-red-200 dark:hover:text-red-300 cursor-pointer h-fit ml-[26px]"
            (click)="closeShiftNotification(notification.type)"
          >
            <lucide-icon class="text-inherit w-[20px] h-[20px]" [img]="crossIcon"></lucide-icon>
          </button>
        </section>
      }
    }
  }
</section>
